document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-legal-page]').forEach((page) => {
    const content = page.querySelector('[data-legal-content]');
    const contents = page.querySelector('[data-legal-contents]');
    const linksContainer = page.querySelector('[data-legal-links]');

    if (!content || !contents || !linksContainer) return;

    const headings = [...content.querySelectorAll('h2')];

    if (!headings.length) {
      contents.hidden = true;
      return;
    }

    contents.hidden = false;
    linksContainer.innerHTML = '';

    const slugify = (text) =>
      text
        .toLowerCase()
        .trim()
        .replace(/&/g, 'and')
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');

    headings.forEach((heading, index) => {
      if (!heading.id) {
        let id = slugify(heading.textContent) || `section-${index + 1}`;

        if (document.getElementById(id)) {
          id = `${id}-${index + 1}`;
        }

        heading.id = id;
      }

      const link = document.createElement('a');

      link.href = `#${heading.id}`;
      link.className = 'legal-page__contents-link';
      link.textContent = heading.textContent.trim();

      link.addEventListener('click', (event) => {
        if (page.dataset.smoothScroll === 'true') {
          event.preventDefault();

          heading.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

          history.replaceState(null, '', `#${heading.id}`);
        }

        heading.classList.remove('legal-heading-highlight');

        requestAnimationFrame(() => {
          heading.classList.add('legal-heading-highlight');
        });
      });

      linksContainer.appendChild(link);
    });

    if (page.dataset.highlightCurrent !== 'true') return;

    const links = [...linksContainer.querySelectorAll('a')];

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          links.forEach((link) => {
            link.classList.toggle(
              'is-active',
              link.getAttribute('href') === `#${entry.target.id}`
            );
          });

          const activeLink = links.find(
            (link) =>
              link.getAttribute('href') === `#${entry.target.id}`
          );

      
        });
      },
      {
        rootMargin: '-25% 0px -65% 0px',
        threshold: 0
      }
    );

    headings.forEach((heading) => observer.observe(heading));
  });
});